// AccessPage.jsx
import { useEffect, useState } from "react";
import UserService from "../../rest/userService";
import ClientService from "../../rest/clientService";
import { toast } from "react-toastify";
import TopNavBar from "../../components/reusables/topNavBar";
import UsersTab from "./components/usersTab";
import PermissionsTab from "./components/permissionTab";

const AccessPage = () => {
    const [users, setUsers] = useState([]);
    const [allPermissions, setAllPermissions] = useState([]);
    const [activeTab, setActiveTab] = useState('users');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const usersData = await UserService.getUsers();
                setUsers(usersData.content);
                const permissionsData = await ClientService.checkPermissions();
                setAllPermissions(permissionsData);
            } catch (err) {
                console.error(err);
                toast.error("Erro ao carregar dados!");
            }
        };
        fetchData();
    }, []);

    return (
        <div className='h-full flex flex-col'>
            <TopNavBar title="Acessos e Permissões" subtitle="" />

            <div className="flex flex-col gap-6 mx-16 my-6">
                <div className="flex border-b mb-4">
                    <button
                        className={`px-4 py-2 font-semibold ${activeTab === 'users' ? 'border-b-2 border-blue-500 text-blue-500' : 'text-gray-500'}`}
                        onClick={() => setActiveTab('users')}
                    >
                        Usuários
                    </button>
                    <button
                        className={`px-4 py-2 font-semibold ${activeTab === 'permissions' ? 'border-b-2 border-blue-500 text-blue-500' : 'text-gray-500'}`}
                        onClick={() => setActiveTab('permissions')}
                    >
                        Permissões
                    </button>
                </div>

                {activeTab === 'users' && (
                    <UsersTab users={users} setUsers={setUsers} />
                )}
                {activeTab === 'permissions' && (
                    <PermissionsTab users={users} allPermissions={allPermissions} />
                )}
            </div>
        </div>
    );
};

export default AccessPage;
